import { css } from '@emotion/react';
import { useKaiProApiState } from '@kaiizen/kai-pro-api-react-state';
import { ReactNode } from 'react';
import { PageLayout } from '../../Layout';
import { LAYOUT2, TYPOGRAPHY2 } from '../../Styles';

const LOADING_CONTENT_STYLE = css`
  label: LOADING_CONTENT_STYLE;
  display: flex;
  flex-direction: column;
  gap: ${LAYOUT2.spacing1}px;
  justify-content: center;
  align-items: center;
  height: 100%;
  ${TYPOGRAPHY2.large}
  color: var(--text);
  background: var(--background);
`;

export const GenericLoadingPage = ({
  title = 'Kai',
  loadingMessage = 'Loading...',
  cannotFetchData = false,
  children,
}: {
  title?: string;
  loadingMessage?: string;
  cannotFetchData?: boolean;
  children?: ReactNode;
}) => {
  const { isOffline } = useKaiProApiState();
  if (isOffline) loadingMessage = 'This page is not available when offline. Please connect to the internet to continue.';
  if (cannotFetchData) loadingMessage = 'Unable to load this page. Please check your internet connection and try again.';
  return (
    <PageLayout title={title}>
      <div css={LOADING_CONTENT_STYLE}>
        <div>{loadingMessage}</div>
        {children}
      </div>
    </PageLayout>
  );
};
